module.exports = __webpack_public_path__ + "img/张红楼.1cfd4784.jpg";